import request from '@/utils/request';

export function WorksListAPI() {
  return {
    // 列表
    getWorksList: params => {
      return request({
        url: '/admin/novel/category/index',
        method: 'get',
        params,
      });
    },
    //新增
    WorksAdded: data => {
      return request({
        url: '/admin/novel/category/edit',
        method: 'post',
        data
      });
    },
    // 详情数据
    detailsList: params => {
      return request({
        url: `/admin/novel/category/info?id=${params}`,
        method: 'get',
      });
    },
    // 删除
    DelList: data => {
      return request({
        url: '/admin/novel/delete',
        method: 'post',
        data
      });
    },
  };
}
